import { RuntimeConfig } from "nuxt/schema"
import { RouteLocationNormalized } from "vue-router"

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const config: RuntimeConfig = useRuntimeConfig()

  if (config.public.APP_ENV === 'demo') {
    if (to.name === 'index') {
      return navigateTo('/dashboard')
    }

    return
  }

  const { $auth } = useNuxtApp()
  const userStore = useUserStore()

  if (to.name === 'index' && $auth.loggedIn && ! userStore.user) {
    return navigateTo('/login')
  }

  if (to.name === 'index' && $auth.loggedIn) {
    return navigateTo('/dashboard')
  }

  if (to.name !== 'index' && !$auth.loggedIn) {
    abortNavigation()
    
    return navigateTo('/')
  }
})
